var TizenVideo = require('./TizenVideo');

module.exports = TizenVideo;
